module.exports = __webpack_public_path__ + "assets/img/sandbox-light-en.b432fe73.png";